import React, { useState, useContext, useEffect } from "react";

import { InfoIcon, MinusCircle, PlusCircle } from "lucide-react";

import RegistrationContext from "../../contexts/RegistrationContext";
import axios from "axios";
import { base_url } from "../../config";
import "./style.scss";
import WhiteBoxLayout from "../../components/WhiteBoxLayout/WhiteBoxLayout";

// Utility function to conditionally join classNames
function cn(...classes: string[]) {
  return classes.filter(Boolean).join(" ");
}

function Options() {
  const { setError, reload, setReload, data, setCart, registrationType } =
    useContext(RegistrationContext);

  const [prices, setPrices] = useState({
    invitationLetter: 5,
    banquetGuests: 0,
    studentGuests: 0,
    receptionGuests: 0,
    diversityLunch: 0,
  });

  useEffect(() => {
    axios.get(`${base_url}/api/get_prices`).then((res) => {
      const t = res.data.event_tickets;
      setPrices((p) => ({
        ...p,
        banquetGuests: t.banquet,
        receptionGuests: t.reception,
        studentGuests: t.student_reception,
        diversityLunch: t.diversity_inclusion,
      }));
    });
  }, []);
  const [selectedItems, setSelectedItems] = useState({
    invitationLetter: data.invitation_letter,
    banquetGuests: data.extra_banquet,
    studentGuests: data.extra_student,
    diversityLunch: data.diversity_inclusion,
    receptionGuests: data.extra_reception,
  });

  const handleSelect = async () => {
    // Reset login error state
    setError("");
    try {
      // Make a POST request to your authentication endpoint
      await axios.post(`${base_url}/api/progress`, {});
      setReload(reload + 1);
    } catch (error: any) {
      setError("Unexpected error. " + error.response.data.message);
    }
  };

  const handleQuantityChange = (
    item: "banquetGuests" | "diversityLunch" | "studentGuests" | "receptionGuests",
    action: "increase" | "decrease"
  ) => {
    const currentValue = selectedItems[item];
    const maxValue = item === "diversityLunch" ? 1 : 3;

    if (action === "increase" && currentValue < maxValue) {
      setSelectedItems({
        ...selectedItems,
        [item]: currentValue + 1,
      });
    } else if (action === "decrease" && currentValue > 0) {
      setSelectedItems({
        ...selectedItems,
        [item]: currentValue - 1,
      });
    }
  };

  const handleCheckboxChange = (item: "invitationLetter") => {
    setSelectedItems({
      ...selectedItems,
      [item]: !selectedItems[item],
    });

  };

  useEffect(() => {
    const run = async () => {
      setError("");
      try {
        const response = await axios.post(`${base_url}/api/update_additional_items`, {
          invitation_letter: selectedItems.invitationLetter ? 1 : 0,
          extra_banquet: selectedItems.banquetGuests,
          extra_student: selectedItems.studentGuests,
          extra_reception: selectedItems.receptionGuests,
          diversity_inclusion: selectedItems.diversityLunch,
        });
        setCart(response.data.cart);
      } catch (error: any) {
        setError("Unexpected error. " + error.response.data.message);
      }
    };
    run();
  }, [selectedItems, setCart, setError]);

  


  const BanquetSelect: React.FC<{ isStudent: boolean }> = ({ isStudent }) => {
    return (<div>
      <div className="flex items-center justify-between mb-2">
        <label htmlFor="banquetGuests" className="font-medium">
          {isStudent? "Banquet entrance ":"Banquet entrance for accompanying person"}
        </label>
        <span className="text-gray-500">
          ${prices.banquetGuests} each
        </span>
      </div>
      <div className="flex items-center space-x-4">
        <button
          className={`inline-flex items-center justify-center h-8 w-8 rounded-md border ${selectedItems.banquetGuests === 0
            ? "opacity-50 cursor-not-allowed"
            : ""
            }`}
          onClick={() =>
            handleQuantityChange("banquetGuests", "decrease")
          }
          disabled={selectedItems.banquetGuests === 0}
        >
          <MinusCircle className="h-4 w-4" />
        </button>
        <span className="w-8 text-center">
          {selectedItems.banquetGuests}
        </span>
        <button
          className={`inline-flex items-center justify-center h-8 w-8 rounded-md border ${selectedItems.banquetGuests === 3
            ? "opacity-50 cursor-not-allowed"
            : ""
            }`}
          onClick={() =>
            handleQuantityChange("banquetGuests", "increase")
          }
          disabled={selectedItems.banquetGuests === 3}
        >
          <PlusCircle className="h-4 w-4" />
        </button>
        <span
          className={cn(
            "ml-auto font-medium",
            selectedItems.banquetGuests === 0 ? "text-gray-500" : ""
          )}
        >
          ${selectedItems.banquetGuests * prices.banquetGuests}
        </span>
      </div>
      <p className="text-xs text-gray-500 mt-1">
        You can purchase up to 3 tickets
      </p>
    </div>);
  }
  const ReceptionSelect = () => {
    return (
      <div>
        <div className="flex items-center justify-between mb-2">
          <label htmlFor="receptionGuests" className="font-medium">
            Reception entrance for accompanying person
          </label>
          <span className="text-gray-500">
            ${prices.receptionGuests} each
          </span>
        </div>
        <div className="flex items-center space-x-4">
          <button
            className={`inline-flex items-center justify-center h-8 w-8 rounded-md border ${selectedItems.receptionGuests === 0
              ? "opacity-50 cursor-not-allowed"
              : ""
              }`}
            onClick={() =>
              handleQuantityChange("receptionGuests", "decrease")
            }
            disabled={selectedItems.receptionGuests === 0}
          >
            <MinusCircle className="h-4 w-4" />
          </button>
          <span className="w-8 text-center">
            {selectedItems.receptionGuests}
          </span>
          <button
            className={`inline-flex items-center justify-center h-8 w-8 rounded-md border ${selectedItems.receptionGuests === 3
              ? "opacity-50 cursor-not-allowed"
              : ""
              }`}
            onClick={() =>
              handleQuantityChange("receptionGuests", "increase")
            }
            disabled={selectedItems.receptionGuests === 3}
          >
            <PlusCircle className="h-4 w-4" />
          </button>
          <span
            className={cn(
              "ml-auto font-medium",
              selectedItems.receptionGuests === 0 ? "text-gray-500" : ""
            )}
          >
            ${selectedItems.receptionGuests * prices.receptionGuests}
          </span>
        </div>
        <p className="text-xs text-gray-500 mt-1">
          You can purchase up to 3 tickets
        </p>
      </div>
    );
  }
  const StudentReceptionSelect = () => {
    return (
      <div>
        <div className="flex items-center justify-between mb-2">
          <label htmlFor="studentGuests" className="font-medium">
            Student reception entrance for accompanying person
          </label>
          <span className="text-gray-500">
            ${prices.studentGuests} each
          </span>
        </div>
        <div className="flex items-center space-x-4">
          <button
            className={`inline-flex items-center justify-center h-8 w-8 rounded-md border ${selectedItems.studentGuests === 0
              ? "opacity-50 cursor-not-allowed"
              : ""
              }`}
            onClick={() =>
              handleQuantityChange("studentGuests", "decrease")
            }
            disabled={selectedItems.studentGuests === 0}
          >
            <MinusCircle className="h-4 w-4" />
          </button>
          <span className="w-8 text-center">
            {selectedItems.studentGuests}
          </span>
          <button
            className={`inline-flex items-center justify-center h-8 w-8 rounded-md border ${selectedItems.studentGuests === 3
              ? "opacity-50 cursor-not-allowed"
              : ""
              }`}
            onClick={() =>
              handleQuantityChange("studentGuests", "increase")
            }
            disabled={selectedItems.studentGuests === 3}
          >
            <PlusCircle className="h-4 w-4" />
          </button>
          <span
            className={cn(
              "ml-auto font-medium",
              selectedItems.studentGuests === 0 ? "text-gray-500" : ""
            )}
          >
            ${selectedItems.studentGuests * prices.studentGuests}
          </span>
        </div>
        <p className="text-xs text-gray-500 mt-1">
          You can purchase up to 3 tickets
        </p>
      </div>
    );
  }
  const DiversityInclusionLunchSelect = () => {
    return (
      <div className="opacity-60">
        <div className="flex items-center justify-between mb-2">
          <label htmlFor="diversityLunch" className="font-medium text-gray-500">
            Diversity and inclusion lunch on Tue, Aug 18th
          </label>
          <span className="text-gray-400 line-through">
            ${prices.diversityLunch} each
          </span>
        </div>
        <div className="flex items-center">
          <span className="inline-flex items-center rounded-md bg-red-100 px-2 py-1 text-xs font-semibold text-red-800">
            Sold out
          </span>
        </div>
        <p className="text-xs text-gray-500 mt-1">
          This option is no longer available.
        </p>
      </div>
    );
  }

  const isStudent = registrationType === "student" || registrationType === "student-paper";

  return (
    <>
      <WhiteBoxLayout title="Options" handleSelect={() => handleSelect()}>
          <h1 className="text-xl font-bold mb-4 ">Additional Items</h1>
          <div className="flex gap-4">
            {/* Invitation Letters Card */}
            <div className="border rounded-lg shadow-sm overflow-hidden flex-1">
              <div className="p-6">
                <h2 className="text-xl font-semibold">Invitation Letters</h2>
                <p className="text-gray-500 text-sm mt-1">
                  Select if you need an invitation letter
                </p>
              </div>
              <div className="px-6 pb-6 space-y-4">
                <div className="flex items-start space-x-2">
                  <div className="flex items-center space-x-2">
                    <input
                      type="checkbox"
                      id="adminLetter"
                      checked={true}
                      //checked={selectedItems.invitationLetter}
                      //onChange={() => handleCheckboxChange("invitationLetter")}
                      className="h-4 w-4 rounded border-gray-300"
                      disabled
                    />
                    <label htmlFor="adminLetter" className="font-medium">
                      Invitation letter for administrative purposes
                    </label>
                  </div>
                  <span className="text-gray-500 ml-auto">Free</span>
                </div>

                <div>
                  <div className="flex items-start space-x-2">
                    <div className="flex items-center space-x-2">
                      <input
                        type="checkbox"
                        id="invitationLetter"
                        checked={selectedItems.invitationLetter}
                        onChange={() => handleCheckboxChange("invitationLetter")}
                        className="h-4 w-4 rounded border-gray-300"
                      />
                      <label htmlFor="invitationLetter" className="font-medium">
                        Invitation letter for visa purposes
                      </label>
                    </div>
                    <span className="text-gray-500 ml-auto">Free</span>
                  </div>
                  <p className="text-xs text-gray-500 mt-1 ml-6">
                    Please select only if you need a VISA to enter Germany.
                    Check the{" "}
                    <a
                      href="https://www.auswaertiges-amt.de/en/visa-service"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-600 underline"
                    >
                      official German visa policy
                    </a>{" "}
                    to confirm whether one is required.
                  </p>
                </div>

                <div className="bg-gray-100 p-4 rounded-md flex items-start space-x-2 mt-4">
                  <InfoIcon className="h-5 w-5 text-gray-500 shrink-0 mt-0.5" />
                  <p className="text-sm text-gray-500">
                    Invitation letters for administrative purposes are issued
                    upon payment.

                  </p>
                  <InfoIcon className="h-5 w-5 text-gray-500 shrink-0 mt-0.5" />
                  <p className="text-sm text-gray-500">

                    Visa invitation letters need to be validated and take up to 72 hours
                    after completion of the registration process.
                  </p>
                </div>
              </div>
            </div>

            {/* Event Tickets Card */}
            <div className="border rounded-lg shadow-sm overflow-hidden flex-1">
              <div className="p-6">
                <h2 className="text-xl font-semibold">Event Tickets</h2>
              
              </div>
              <div className="px-6 pb-6 space-y-6">
                {/* Banquet Guests */}
                <BanquetSelect isStudent={isStudent}/>
                <ReceptionSelect />
                {isStudent && <StudentReceptionSelect />}
                <DiversityInclusionLunchSelect />
              </div>
            </div>
          </div>
      </WhiteBoxLayout>
    </>
  );
}

export default Options;

